<template>
    <div class="w-5 h-5 flex items-center justify-center">
        <svg width="22" height="17" viewBox="0 0 22 17" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.46 7.33002H0V8.83002H21.46V7.33002Z" :fill="color"/>
            <path d="M21.46 0H0V1.5H21.46V0Z" :fill="color"/>
            <path d="M21.46 14.66H0V16.16H21.46V14.66Z" :fill="color"/>
        </svg>
    </div>
</template>

<script setup>
defineProps({
    color: {
        type: String,
        required: false,
        default: '#1C1C1C'
    }
});

</script>
